import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Tag from 'shopper/components/Tag/V2';
import Text from 'shopper/components/Text';

import { toStoreCouponsLink, toStoreOffersLink } from 'lib/links';

const TIMELINES = [
  {
    name: 'Cupons',
    getUrl: toStoreCouponsLink,
    icon: 'ticket-simple',
  },
  {
    name: 'Ofertas',
    getUrl: toStoreOffersLink,
    icon: 'fire',
  },
];

export const stripHashMark = (url) => url.split('#')[0];

const TimelineNavigator = ({
  className,
  couponsCount,
  hasMoreOffers,
  offersCount,
  storeName,
  storeSlug,
}) => {
  const router = useRouter();

  return (
    <div className={className}>
      {storeName && (
        <Text
          as="h2"
          className="mb-4 font-bold text-neutral-low-400 dark:text-neutral-high-200 lg:text-xl"
          size="size1"
        >
          Cupom {storeName}: confira todos os cupons de desconto atualizados
        </Text>
      )}
      <nav className="flex gap-x-4">
        {TIMELINES.map(({ icon, name, getUrl }) => {
          const url = getUrl(storeSlug);
          const isActive = stripHashMark(router.asPath) === url;
          const label =
            name === 'Cupons' && couponsCount != null
              ? `Cupons (${couponsCount})`
              : name === 'Ofertas' && offersCount != null
                ? `Ofertas (${offersCount}${hasMoreOffers ? '+' : ''})`
                : name;

          return (
            <NextLink key={name} href={url} prefetch={false} passHref>
              <Tag
                as="a"
                className="text-sm lg:text-base"
                clickable={!isActive}
                filled={isActive}
                iconLeft={<Icon name={icon} />}
                size="size1"
                type={isActive ? 'primary' : 'neutral'}
                bold
              >
                {label}
              </Tag>
            </NextLink>
          );
        })}
      </nav>
    </div>
  );
};

TimelineNavigator.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  couponsCount: PropTypes.number,
  hasMoreOffers: PropTypes.bool,
  offersCount: PropTypes.number,
  storeName: PropTypes.string,
  storeSlug: PropTypes.string.isRequired,
};

export default TimelineNavigator;
